import React, { useState, useEffect } from "react";
import "../styles/stocklist.scss";
import { Input, Flex } from "@chakra-ui/react";
import { isEmpty } from "lodash";

const StockSingleCard = ({ product }) => {
  const [productState, setProductState] = useState({});

  useEffect(() => {
    if (product.productId) {
      setProductState({ ...product });
    }
  }, [product]);

  return (
    <Flex justify="space-between" align="flex-end">
      {!isEmpty(productState) && (
        <>
          <div className="input-wrapper">
            <span className="input-label">Available Stock</span>
            <div className="input">
              <Input
                disabled
                value={productState?.warehouseStocks[0]?.availableStock || 0}
              />
            </div>
          </div>
          <div className="input-wrapper">
            <span className="input-label">Min Safety Stock</span>
            <div className="input">
              <Input
                disabled
                placeholder
                value={productState?.warehouseStocks[0]?.minSafetyStock || 0}
              />
            </div>
          </div>
          <div className="input-wrapper">
            <span className="input-label">QC Stock</span>
            <div className="input">
              <Input
                disabled
                value={productState?.warehouseStocks[0]?.qcStock || 0}
              />
            </div>
          </div>
          <div className="input-wrapper">
            <span className="input-label">Reserved Stock</span>
            <div className="input">
              <Input
                disabled
                value={productState?.warehouseStocks[0]?.reservedStock || 0}
              />
            </div>
          </div>
        </>
      )}
    </Flex>
  );
};

export default StockSingleCard;
